import { Deserializable } from '../interfaces';

export class Confirm implements Deserializable {
  title: string;
  text: string;
  acceptText: string;
  cancelText: string;

  constructor() {
    this.title = '';
    this.text = '';
    this.acceptText = 'accept';
    this.cancelText = 'cancel';
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
